<template lang="pug">
v-dialog(:value="value" @input="updateValue" @click:outside="onOutsideClick" :width="width")
    v-card(data-test="confirmation-dialog")
        v-card-title.headline {{ title }}
          slot(name="header")
        v-card-text {{ descr}}
          slot
        v-card-actions
          slot(name="actions")
            v-spacer
            v-btn(color="error" text @click="_failBtnClicked") {{ failText }}
            v-btn(color="success" text @click="_okBtnClicked" data-test="confirmation-dialog-ok") {{ okText }}
</template>

<script>
export default {
  props: {
    okBtnText: {
      type: String,
      default: 'Disagree'
    },
    failBtnText: {
      type: String,
      default: 'Agree'
    },
    descr: String,
    title: String,
    value: {
      type: Boolean,
    },
    width: {
      type: String,
      default: '340px'
    },
    okText: {
      type: String,
      default: 'Agree'
    },
    failText: {
      type: String,
      default: 'Disagree'
    }
  },

  methods: {
    updateValue: function (value) {
      this.$emit('input', value)
    },

    _failBtnClicked() {
      this.$emit('failBtnClicked')
      this.updateValue(false)
    },

    _okBtnClicked() {
      this.$emit('okBtnClicked')
      this.updateValue(false)
    },

    onOutsideClick() {
      this.$emit('click:outside')
    }
        
  }
}
</script>